<template lang="html">
  <v-container>
    <router-view></router-view>
    <v-row>
      <v-col class="xs-6" cols="6">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{ getBusiness.name }}
              {{ $t('Company.Manage.Member.Members') }}</v-toolbar-title>
            <v-spacer />
            <button v-if="hasBusinessPermission('Add Users')" style="margin-right: 10px" :class="`company-manage-filter-button ${show_filter ? 'primary' : 'color-3'}`" v-ripple
              @click="exportMembersAsCSV()">
              <TIcon name="download" :color="show_filter ? 'color-3' : 'primary'" />
            </button>
            <button :class="`company-manage-filter-button ${show_filter ? 'primary' : 'color-3'}`" v-ripple
              @click="show_filter = !show_filter">
              <TIcon name="filter" :color="show_filter ? 'color-3' : 'primary'" />
            </button>
          </v-toolbar>
          <div v-if="show_filter" class="company-manage-filter-container">
            <SearchBar :is_live_emit="true" @search="search = $event; selectIndex(0)" />
            <DropDownOutlinedFlat label="Sort by" :options="sort_options" :value="sort" width="200"
              background_color="color-4" :foreground_color="$vuetify.theme.isDark ? '#fff' : '#000'"
              @change="sort = $event" />

          </div>
          <v-row>
            <v-col xs5 cols="5" class="members-setting-default-height">
              <StandardMembersList @selectIndex="selectIndex($event), add_new = false" :members="members"
                :selected_index="selected_index" :current_user="getUser" :add_user="true">
                <template #add-member>
                  <v-list-item v-if="hasBusinessPermission('Add Users')">
                    <v-list-item-avatar class="cursor-pointer" :color="add_new ? 'green' : 'grey'" small @click="!add_new ? add_new = true : (addUsers({
                      business_id: getBusiness.id,
                      payload: { users: [{ email: new_member.email, brole_id: new_member.brole.id }] }
                    }), resetNewMember())">
                      <v-progress-circular v-if="isLoadingMembers" :size="40" width="4" center indeterminate />
                      <v-icon v-else-if="!add_new">add</v-icon>
                      <v-icon class="ml-1" v-else>send</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content v-if="isLoadingMembers">
                      adding Member...
                    </v-list-item-content>
                    <div v-else-if="add_new">
                      <v-list-item-content>
                        <StandardTextfield color="grey darken-1" textcolor="white" placeholder="Email Address"
                          :value="new_member.email" @changeValue="setNewUserEmail($event)" style="width: 90%"
                          :readonly="isLoadingMembers" />
                        <StandardDropdown style="margin-top: 5px;"
                          :value="new_member.brole.id !== 0 ? new_member.brole.name : 'select Role'"
                          color="grey darken-1" :options="getUObjects({ type: 'broles', ids: getBusiness.broles })"
                          @changeValue="setNewUserBRole($event)" :readonly="isLoadingMembers" />
                      </v-list-item-content>
                    </div>
                    <v-list-item-content v-else @click="add_new = true" class="cursor-pointer">
                      {{ $t('Company.Manage.Member.AddMember') }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-alert v-if="getAddMemberError !== ''" type="error" @click="resetAddMemberError()">
                    {{ getAddMemberError }}
                  </v-alert>
                </template>
              </StandardMembersList>
            </v-col>
            <v-col xs7 cols="7" class="members-setting-default-height">
              <StandardMembersDetails :member="members[selected_index]">
                <template #role="{ member }">
                  <v-list-item-title v-if="!edit_role">{{ member.brole.name }}</v-list-item-title>
                  <v-list-item-title v-if="edit_role">
                    <StandardDropdown class="ma-0" header="Select Role:" :value="change_brole.name"
                      @changeValue="change_brole = $event" placeholder="Business Roles"
                      :options="getUObjects({ type: 'broles', ids: getBusiness.broles })" />
                  </v-list-item-title>
                </template>
                <template #role-actions="{ member }">
                  <v-btn v-if="hasBusinessPermission('Add Users') && !edit_role" icon color="green" class="pull-right"
                    @click="edit_role = true">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn v-if="edit_role" icon color="red" class="pull-right" @click="edit_role = false">
                    <v-icon>cancel</v-icon>
                  </v-btn>
                  <v-btn v-if="edit_role" icon color="green" class="pull-right" @click="requestUpdateMemberBRole({
                    business_id: getBusiness.id,
                    payload: { users: [{ id: member.id, brole_id: change_brole.id }] },
                    usersbusiness_id: member.usersbusiness_id
                  })">
                    <v-icon>done</v-icon>
                  </v-btn>
                </template>
                <template #remove-member="{ member }">
                  <v-list-item v-if="show_delete">
                    <div style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;height: 100%;width: 100%;">
                      <RadialCheckbox :is_checked="checkbox_remove_from_projects" @setActive="checkbox_remove_from_projects = !checkbox_remove_from_projects" />
                      <TText value="Remove user from company projects" />
                    </div>
                  </v-list-item>

                  <v-list-item v-if="hasBusinessPermission('Remove Users') && getUser.id !== member.id"
                    class="list-item-bg">
                    <v-list-item-action v-if="show_delete">
                      <v-btn @click="show_delete = false;" icon><v-icon color="snow">cancel</v-icon></v-btn>
                    </v-list-item-action>
                    <v-list-item-content v-if="!show_delete">
                      <v-btn @click="show_delete = true" text>{{ $t('Company.Manage.Member.RemoveMember') }} {{
                        member.first_name + ' ' + member.last_name
                      }}</v-btn>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                      <v-btn @click="removeUsers({
                        business_id: getBusiness.id,
                        usersbusiness_id: member.usersbusiness_id,
                        payload: { users: [{ id: member.id }], remove_from_projects: checkbox_remove_from_projects }
                      }), resetMemberDetails()" text>{{ $t('Company.Manage.Member.ClickbaitRemoveMember') }}
                        {{ member.first_name + ' ' + member.last_name }}</v-btn>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </StandardMembersDetails>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col class="xs-6" cols="6">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{ getBusiness.name }}
              {{ $t('Company.Manage.Project.BusinessProjects') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <span v-if="hasBusinessPermission('Remove Projects')">
              <v-btn small :disabled="selection.length === 0" v-if="projects_select" text color="red"
                @click="requestRemoveProjects()">{{ $t('Company.Manage.Project.RemoveProjects') }}</v-btn>
              <v-btn small @click="projects_select = !projects_select">{{ projects_select? 'select': 'route' }}</v-btn>
            </span>
          </v-toolbar>
          <v-row>
            <v-col xs12 class="members-setting-default-height">
              <div class="ml-5 mr-5">
                <v-row>
                  <StandardCard v-for="project in getBusinessProjects" :key="project.id" :image="project.image"
                    :name="project.name" :cols="4" clickable="true" @click.native="projectClick(project)">
                    <template #badge>
                      <StandardBadge v-if="projects_select" :show_icon_cond="isInSelection(project.id)" :zoom="0.8"
                        show_icon="done" color="white" content_color="black" />
                    </template>
                  </StandardCard>
                  <StandardCard v-if="hasBusinessPermission('Add Projects')" key="add_project_to_business" icon="add"
                    :name="'Add Projects to ' + getBusiness.name" :cols="4" clickable="true"
                    @click.native="$router.push({ name: 'CompanyAddProjects' })">
                  </StandardCard>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- ROLES + PERMISSIONS CONFIGURATION -->

    <v-row>
      <v-col class="xs-12">
        <v-card class="mb-10">
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3" style="display: flex; width: 100%;">
            {{ $t('Company.Manage.Roles.Title') }}
            <!-- text input field for bpermission_search -->
            <v-text-field
                v-model="bpermission_search"
                label="Filter Business Permissions"
                single-line
                hide-details
                class="ml-3"
                style="width: 200px;"
              ></v-text-field>
            </v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-group
              v-for="(brole, brole_index) in getUObjects({ type: 'broles', ids: getUObject({ type: 'businesses', id: getBusiness.id }).broles })"
              :key="`broles${brole.id}`" :value="brole_show_index === brole_index"
              @input="brole_show_index = brole_index" no-action>
              <template #prependIcon>
                <v-list-item-action>
                  <v-btn icon @click.stop="add_is_active = !add_is_active">
                    <v-icon color="green">mode_edit</v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
              <template #appendIcon>
                <v-list-item-action v-if="hasBusinessPermission('Delete Roles')" style="display: flex; flex-direction: row-reverse; align-items: center;">
                  <StandardDeleteBtn @deleteClick="deleteUObject({
                    url: [
                      { businesses: getBusiness.id },
                      { broles: brole.id }
                    ]
                  })" />
                  <ButtonOutlined
                    value="Remove All"
                    color="warning"
                    width="80"
                    height="40"
                    text_size="8"
                    padding="3"
                    class="mr-3"
                    @click.native.stop="removeAllPermissions(brole)"
                  />
                  <ButtonOutlined
                    value="Add All"
                    color="success"
                    width="80"
                    height="40"
                    text_size="8"
                    padding="3"
                    class="mr-3"
                    @click.native.stop="addAllPermissions(brole)"
                  />
                </v-list-item-action>
              </template>

              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="brole.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="brole.description"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            <v-list-item 
                v-for="bpermission in getUObjects({type: 'allbpermissions'}).filter(bpermission => bpermission.name.toLowerCase().includes(bpermission_search.toLowerCase()))"
                :key="`bpermissions${bpermission.id}`" style="cursor: pointer;"
                :class="brole.bpermissions.indexOf(bpermission.id) !== -1 ? 'green' : ''"
                @click="brole.bpermissions.indexOf(bpermission.id) !== -1 ? removeBPermission({ business_id: getBusiness.id, brole_id: brole.id, bpermission_id: bpermission.id }) : addBPermission({ business_id: getBusiness.id, brole_id: brole.id, bpermission_id: bpermission.id })">
                <v-list-item-icon><v-icon
                    v-if="brole.bpermissions.indexOf(bpermission.id) !== -1">done</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="bpermission.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="bpermission.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-if="hasBusinessPermission('Update Roles')">
              <v-list-item-icon>
                <v-icon v-if="!add_is_active" @click="add_is_active = true">add</v-icon>
                <v-icon v-if="add_is_active" @click="addNewRole()" color="green">send</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-if="hasBusinessPermission('Add Roles') && !add_is_active"
                @click="add_is_active = true" style="cursor: pointer;">
                <v-list-item-title>NEW.role</v-list-item-title>
                <v-list-item-subtitle>Create a new project role.</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content v-if="hasBusinessPermission('Add Roles') && add_is_active">
                <v-list-item-title>
                  <StandardDataField text_color="snow" placeholder="ROLE.name" :value="new_role_name"
                    @changeValue="new_role_name = $event" />
                </v-list-item-title>
                <v-list-item-subtitle>
                  <StandardDataField text_color="snow" placeholder="ROLE.description" :value="new_role_description"
                    @changeValue="new_role_description = $event" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>

import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import store from '@/store/index';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue'
import StandardMembersList from '@/components/StandardComponents/StandardMembersList.component.vue'
import StandardMembersDetails from '@/components/StandardComponents/StandardMembersDetails.component.vue'
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue';
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue'
import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CompanyManage',
  components: {
    DropDownOutlinedFlat,
    ButtonOutlined,
    RadialCheckbox,
    StandardMembersList,
    StandardDropdown,
    StandardMembersDetails,
    StandardTextfield,
    StandardCard,
    StandardBadge,
    StandardDataField,
    StandardDeleteBtn,
    SearchBar,
    TIcon,
  },
  data: function () {
    return {
      selected_index: 0,
      show_delete: false,
      edit_role: false,
      change_brole: {
        name: '',
        id: 0
      },
      add_new: false,
      new_member: {
        email: '',
        brole: {
          id: 0,
          name: ''
        }
      },
      projects_select: false,
      selection: [],
      brole_show_index: -1,
      add_is_active: false,
      new_role_name: '',
      new_role_description: '',
      show_filter: false,
      sort: '',
      search: '',
      checkbox_remove_from_projects: true,
      bpermission_search: '',
    }
  },
  created() {
    store.dispatch('Business/requestAllBPermissions', {});

  },
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects'
    ]),
    ...mapGetters('Business', [
      'getBusiness',
      'getAddMemberError',
      'getBusinessProjects',
      'getBusinessMembers',
      'getBusinessRoles',
      'hasBusinessPermission',
      'isLoadingMembers'
    ]),
    members() {
      let terms = this.search.split(' ');
      let ret = this.getBusinessMembers;
      let sort = this.sort.split('-');
      if (sort[0]) {
        this.sortObjectArrayByValueOfKey(ret, sort[0]);
        if (sort[1] == 'dsc') {
          ret.reverse();
        }
      }
      else if (sort[0] === '') {
        ret.sort(function (a, b) { return a.usersbusiness_id - b.usersbusiness_id });
      }

      terms.forEach(term => {
        ret = ret.filter(element =>
          element.first_name.toLowerCase().includes(term.toLowerCase()) ||
          element.last_name.toLowerCase().includes(term.toLowerCase()) ||
          element.email.toLowerCase().includes(term.toLowerCase())
        )
      });
      return ret;
    },
    sort_options() {
      return [
        { value: '', text: '' },
        { value: 'first_name-asc', text: 'First Name (a-z)' },
        { value: 'first_name-dsc', text: 'First Name (z-a)' },
        { value: 'last_name-asc', text: 'Last Name (a-z)' },
        { value: 'last_name-dsc', text: 'Last Name (z-a)' },
        { value: 'email-asc', text: 'Email (a-z)' },
        { value: 'email-dsc', text: 'Email (z-a)' },
      ];
    },
  },
  methods: {
    ...mapActions('Ultra', [
      'createUObject',
      'deleteUObject'
    ]),
    ...mapActions('Business', [
      'addUsers',
      'removeUsers',
      'updateMemberBRole',
      'removeProjects',
      'resetAddMemberError',
      'removeBPermission',
      'addBPermission',
    ]),
    exportMembersAsCSV() {
      let csv = {}
      this.members.forEach(member => {
        csv[member.id] = {
          name: member.first_name + ' ' + member.last_name,
          email: member.email,
          role: member.brole.name
        }
      })
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "name,email,role\r\n";
      Object.values(csv).forEach(function(rowObject) {
          let row = Object.values(rowObject).join(",");
          csvContent += row + "\r\n";
      });
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "company_members.csv");
      document.body.appendChild(link);
      link.click();
    },
    // NOTE: this is copied from the WorkPackageWIPMixin - maybe move this method to a store or another mixin
    // sorts an array of objects alphabetically by a (string) value of a specific key
    sortObjectArrayByValueOfKey(array, sort_key) {
      array.sort((a, b) => {
        // we check every char if they're the same, if not sort accordingly
        // TODO: check for ö, ä, ü, ß
        let min = Math.min(a[sort_key].length, b[sort_key].length);
        for (let i = 0; i < min; i++) {

          if (a[sort_key][i].toLowerCase() !== b[sort_key][i].toLowerCase()) {
            return a[sort_key][i].toLowerCase() > b[sort_key][i].toLowerCase() ? 1 : -1;
          }
        }

        // all chars were the same, shorter string is prioritized
        if (a[sort_key].length != b[sort_key].length) {
          return a[sort_key].length === min ? -1 : 1;
        }

        // string matches exactly, no preference
        return 0;
      });
    },
    addNewRole() {
      let self = this;
      this.createUObject({
        url: [
          { businesses: this.getBusiness.id },
          { broles: '' },
          { showWithEntitiesNormalized: '' }
        ],
        u_object: {
          name: self.new_role_name,
          description: self.new_role_description,
          bpermissions: []
        }
      }).then(() => {
        self.add_is_active = false;
        self.new_role_name = '';
        self.new_role_description = '';
      });
    },
    requestUpdateMemberBRole(payload) {
      this.updateMemberBRole(payload);
      let self = this;
      setTimeout(function () {
        self.edit_role = false;
      }, 1500);
    },
    selectIndex(index) {
      this.selected_index = index;
      this.show_delete = false;
    },
    setNewUserEmail(event) {
      this.new_member.email = event;
    },
    setNewUserBRole(event) {
      this.new_member.brole = event;
    },
    selectOrDeselect(id) {
      let index = this.selection.indexOf(id);
      if (index === -1) {
        this.selection.push(id);
      } else {
        this.selection.splice(index, 1);
      }
    },
    isInSelection(id) {
      if (this.selection.indexOf(id) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    projectClick(project) {
      if (this.projects_select) {
        // select / deselect
        this.selectOrDeselect(project.id);
      } else {
        // route to project
        if (project.calling_user_is_member) {
          this.$router.push({ name: 'Project', params: { project_id: project.id } });
        } else {
          this.$router.push({ name: 'CompanyJoinProject', params: { project_id: project.id } });
        }
      }
    },
    requestRemoveProjects() {
      let projects = [];
      for (let i = 0; i < this.selection.length; i++) {
        projects.push({ id: this.selection[i] });
      }
      this.removeProjects({
        business_id: this.getBusiness.id,
        payload: { projects: projects }
      });
    },
    resetNewMember() {
      this.new_member = {
        email: '',
        brole: {
          id: 0,
          name: ''
        }
      };
      this.add_new = false;
    },
    resetMemberDetails() {
      this.selected_index = 0;
      this.show_delete = false;
    },
    addAllPermissions(brole){
      this.getUObjects({type: 'allbpermissions'}).forEach((bpermission) => {
        if(brole.bpermissions.indexOf(bpermission.id) === -1) {
          this.addBPermission({business_id: this.getBusiness.id, brole_id: brole.id, bpermission_id: bpermission.id});
        }
      });
    },
    // addBPermission({ business_id: getBusiness.id, brole_id: brole.id, bpermission_id: bpermission.id })
    removeAllPermissions(brole){
      this.getUObjects({type: 'allbpermissions'}).forEach((bpermission) => {
        if(brole.bpermissions.indexOf(bpermission.id) !== -1) {
          this.removeBPermission({business_id: this.getBusiness.id, brole_id: brole.id, bpermission_id: bpermission.id});
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.members-setting-default-height {
  max-height: 600px;
  overflow-y: auto;
}

.list-item-bg {
  background-color: red;
}

.company-manage-filter-button {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.company-manage-filter-container {
  height: 64px;
  width: 100%;
  display: flex;
  grid-gap: 36px;
  align-items: center;
}
</style>
